export { default as Galeria } from './GaleriaView'
export { GaleriaViewProps } from './Galeria.types'
